import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

import { EN_DATE_FORMAT, FR_DATE_FORMAT, TranslateService } from '@connect-services/client/services/translate.service';

export enum DayOfWeekEnum {
    SUNDAY = 0,
    MONDAY = 1,
}

@Injectable({
    providedIn: 'root',
})
export class CustomDateAdapterService extends NativeDateAdapter {
    public constructor(private translateService: TranslateService) {
        super(translateService.getCurrentLang());
    }

    public static getDateWithoutTime(date: Date): Date {
        return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    }

    public datePickerFilter = (d: Date | null): boolean => {
        const day = CustomDateAdapterService.getDateWithoutTime(d || new Date());
        const today = CustomDateAdapterService.getDateWithoutTime(new Date());

        return day >= today;
    };

    //Override the format method from Material Datepicker
    public override format(date: Date): string {
        // It sounds strange, but when I pass a date at a certain time, it's not considered a date.
        return this.translateService.getFormattedLocaleDate(date instanceof Date ? date : new Date(date));
    }

    //Override method from Material Datepicker who convert user input into a Date object
    public override parse(value: string): Date | null {
        if (!value) {
            return null;
        }

        const dateFormat = this.translateService.getDateFormat();
        let parts: string[];

        if (dateFormat === FR_DATE_FORMAT) {
            parts = value.split('/');
            if (parts.length === 3) {
                const day = parseInt(parts[0], 10);
                const month = parseInt(parts[1], 10) - 1;
                const year = parseInt(parts[2], 10);

                return new Date(year, month, day);
            }
        } else if (dateFormat === EN_DATE_FORMAT) {
            parts = value.split('/');
            if (parts.length === 3) {
                const month = parseInt(parts[0], 10) - 1;
                const day = parseInt(parts[1], 10);
                const year = parseInt(parts[2], 10);

                return new Date(year, month, day);
            }
        }

        // return an invalid date to be catch by validator
        return new Date(NaN);
    }
}
